import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toggleMobileAppFlagOfCluster } from '../../../api/mobileAppClientsApi';

function useToggleMobileAppFlagOfCluster() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ clusterId, hasMobileApp }) =>
      toggleMobileAppFlagOfCluster(clusterId, hasMobileApp),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['mobile-clusters']);
      },
    }
  );
}

export default useToggleMobileAppFlagOfCluster;
